module.exports = __webpack_public_path__ + "static/media/Skuntank_gaussian2.27a79c7c.png";